import { apiBaseUrl } from "../utils/constants/env.constants";

class LoginAPIs {
  // Send OTP
  static async sendOtp({ axiosPublic, payload }) {
    const url = `${apiBaseUrl}/api/v1/auth/send-otp/`;
    const response = await axiosPublic.post(url, payload);
    return { response };
  }

  // Verifies OTP
  static async verifyOtp({ axiosPublic, payload }) {
    const hostEndPoint = "/api/v1/auth/verify-otp/";
    const url = `${apiBaseUrl}${hostEndPoint}`;
    const response = await axiosPublic.post(url, payload);
    return { response };
  }

  // ME API to get the current user with status check
  static async getProfile({ axiosPrivate, config = {} }) {
    const url = `/api/v1/users/me/`;
    const response = await axiosPrivate.get(url, config);

    // Fetch full profile to get status as 'me' endpoint might not have it
    const userId = response?.data?.data?.user?.id;
    if (userId) {
      try {
        const userUrl = `/api/v1/agency/users/${userId}/`;
        const userResponse = await axiosPrivate.get(userUrl);
        const fullUser = userResponse?.data?.data ?? userResponse?.data;

        if (response?.data?.data?.user && fullUser) {
          if (fullUser.status !== undefined) response.data.data.user.status = fullUser.status;
          if (Object.prototype.hasOwnProperty.call(fullUser, "agency_id")) response.data.data.user.agency_id = fullUser.agency_id ?? null;
          if (fullUser.agency) response.data.data.user.agency = fullUser.agency;
        }
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error("Status fetch failed", error);
        }
      }
    }
    return { response };
  }
  // Google Login
  static async googleLogin({ axiosPublic, payload }) {
    const hostEndPoint = "/api/v1/auth/google-login/";
    const url = hostEndPoint;
    const response = await axiosPublic.post(url, payload);
    return { response };
  }

  static async saveGoogleSheetsToken({ axiosPrivate, code }) {
    const res = await axiosPrivate.post("/api/v1/auth/save-google-token/", { code });
    return res?.data?.data ?? res?.data;
  }
}

export default LoginAPIs;
